<!--
 * @Description:风控记录列表
 * @Date: 2023-04-13 16:13:52
 -->
<template>
  <div class="dialog">
    <el-dialog
      title="修改记录"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-table :data="handleList">
        <el-table-column
          align="center"
          property="date"
          label="修改时间"
          width="500"
        >
          <template slot-scope="{ row }">
            {{ row.updateTime | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="name"
          label="生效时间"
          width="500"
        >
          <template slot-scope="{ row }">
            {{ row.enableDt | transAllTime }}
          </template>
        </el-table-column>
        <!-- <el-table-column property="address" label="修改来源" align="center">
          <template slot-scope="{ row }">
            {{ row.enterpriseId || row.userId || user.id }}
          </template>
        </el-table-column> -->
        <el-table-column
          property=" address
          "
          label="修改记录"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="checkout(scope)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="paginationData.totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
      <div slot="footer">
        <el-button type="primary" style="margin-top: 1em" @click="close">
          确定
        </el-button>
      </div>
    </el-dialog>
    <seeDetalisModel
      :visible.sync="showDetail"
      :remarkMap="remarkMap"
      :updateJson="updateJson"
    ></seeDetalisModel>
  </div>
</template>

<script>
import { getStorage } from '@/tools/storage';
import seeDetalisModel from './components/seeDetalisModel.vue';
import { riskControl } from '@/api/ajax';
export default {
  name: 'dialoge',
  props: {
    projectId: String,
    visible: {
      default: true
    }
  },
  data() {
    return {
      remarkMap: {
        collectionType: 3,
        enterpriseId: '',
        haveTimeSubject: 1
      },
      updateJson: {},
      handleList: [],
      paginationData: {
        pageNum: 1,
        pageSize: 15,
        totalElements: 0
      },
      user: { username: '', id: '' },
      showDetail: false,
      searchQuery: {}
    };
  },
  components: {
    seeDetalisModel
  },
  watch: {},
  computed: {},
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.paginationData.pageNum = val;
      this.initTabelData();
    },
    close() {
      this.$emit('update:visible', false);
    },
    checkout(e) {
      this.showDetail = true;
      this.updateJson = JSON.parse(e.row.updateJson);
    },
    initTabelData() {
      let params = {
        projectId: this.projectId,
        pageNo: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize
      };
      riskControl.investigate.dcwjRiskHistory(params).then(res => {
        if (+res.data.code == 1) {
          this.remarkMap = res.data.data.remarkMap;
          this.handleList = res.data.data.list.map(item => {
            item['updateTime'] = JSON.parse(item.updateJson)['updateTime'];
            item['enableDt'] = JSON.parse(item.updateJson)['enableDt'];
            item['enterpriseId'] = this.remarkMap.enterpriseId;
            return item;
          });
          this.paginationData.totalElements = res.data.data.total;
        }
      });
    }
  },
  created() {
    Object.assign(this.searchQuery, this.$parent.dialogQuery);
    this.user = getStorage('user') || {};
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.dialog {
  .el-dialog {
    width: 90vw;
    /*标题样式*/
    .el-dialog__header {
      background-color: #5a9cf8;
      padding: 0px;
      height: 48px;

      .el-dialog__title {
        font-size: 20px;
        color: #ffffff;
      }
    }

    /*输入框后面加<元>*/
    .el-dialog__body {
      padding: 30px;
      border-bottom: 1px #dfe1e6 solid;

      .el-form-item {
        margin-bottom: 15px;
      }
    }

    /*底部按钮居中和大小*/
    .el-dialog__footer {
      height: 89px;
      padding: 0;
      display: flex;
      justify-content: center;

      .dialog-footer {
        align-self: center;

        .el-button {
          width: 155px;
          height: 39px;
        }
      }
    }
  }
}
</style>
